import { Jodit } from 'jodit-react';
import { sanitizeHtml } from './util';

export type CustomCssDetectionPluginOptions = {
  readonly onPaste: (html: string, editor: Jodit) => boolean;
};

export class CustomCssDetectionPlugin {
  private jodit: Jodit;
  private options: CustomCssDetectionPluginOptions;

  constructor(jodit: Jodit) {
    this.jodit = jodit;
  }

  init(): void {
    this.options = (this.jodit.o as unknown as { customCssDetectionPlugin: CustomCssDetectionPluginOptions }).customCssDetectionPlugin;

    if (!this.options) {
      return;
    }

    this.jodit.e.on('paste', (event: ClipboardEvent) => {
      event.preventDefault();
      this.jodit.e.stopPropagation('paste');
      this.handlePaste(event);
    });
  }

  private handlePaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    if (!clipboardData) {
      return;
    }

    const { Helpers } = Jodit.modules;
    const dt = Helpers.getDataTransfer(event);

    // Try HTML first
    const html = dt?.getData(Jodit.constants.TEXT_HTML);

    if (html) {
      // Call the callback - if it returns true, it handled the paste
      const handled = this.options.onPaste(html, this.jodit);
      if (!handled) {
        // Callback didn't handle it, insert normally
        this.jodit.s.insertHTML(sanitizeHtml(html));
      }
    } else {
      // Fallback to plain text
      const text = dt?.getData(Jodit.constants.TEXT_PLAIN);
      if (text) {
        this.jodit.s.insertHTML(sanitizeHtml(text));
      }
    }
  }

  destroy(): void {
    this.jodit.e.off('paste');
  }
}
